module.exports = __webpack_public_path__ + "resource/img/newMateriel.bd500244.png";